<template>
<div :class="`${config.widescreen?'wide-container':''}`">
    <div class="container" v-if="config.error">
        <Error :code="config.status_code?config.status_code:403" :msg="config.detail"/>
    </div>
    <template v-if="!config.error && ctrl_component">
        <!-- 页面访问情况 -->
        <NewPlatformBtn />
        <PageVisit />
        <!-- 搜索栏 -->
        <SearchBar />
        <!-- 全局提示 -->
        <GlobalAlert />
        <!-- 上线提示 -->
        <OnlineManage />

        <!-- 基本模板 -->
        <div class="container" v-if="['common', 'dynamic', 'tabs', 'compare', 'balance', 'download', 'report'].indexOf(config.ctrl) >= 0">
            <PageHeader style="margin:10px 0 0 0;"/>
            <div class="content page_main_content">
                <component :is="ctrl_component"></component>
            </div>
        </div>
        <!-- 特殊模板 -->
        <component :is="ctrl_component" :parent="config.parent" :name="config.name" v-else></component>
    </template>
</div>
</template>  

<script>
import {Tabs as ATabs, Divider} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(ATabs)
Vue.use(Divider)

import PageHeader from '@/components/game/pageheader.vue'
import NewPlatformBtn from '@/components/game/newPlatformBtn.vue'
import Error from '@/components/error/error.vue'
import SearchBar from '@/components/game/menu/searchbar.vue'
import PageVisit from '@/components/game/pagevisit.vue'
import GlobalAlert from '@/components/common/alert.vue'
import OnlineManage from '@/components/game/onlinemanage.vue'

export default {
    components: {
        NewPlatformBtn,
        PageVisit,
        Error,
        GlobalAlert,
        SearchBar,
        OnlineManage,
        PageHeader,
    },
    created() {
        const id = this.$route.query.id
        if (id) {
            const modules = this.$store.state.game.modules
            for (const module of modules) {
                if (module.sub) {
                    const sub = module.sub.find(s => String(s.id) === String(id))
                    if (sub && sub.ctrl) {
                        this.$router.push({ path: `/${module.ctrl}` })
                        return
                    }
                }
            }
        }
        this.getConfig()
    },
    computed: {
        info() {
            return this.$store.state.game.info
        },
        config() {
            const _config = this.$store.state.config.page
            if(_config && _config.watermark===false && window.WaterMark) {
                window.WaterMark.clear()
            }
            return _config
        },
        ctrl_component() {
            if(!this.config.ctrl) {
                return null
            }
            if(['common', 'dynamic', 'tabs', 'compare', 'balance', 'download', 'report'].indexOf(this.config.ctrl) >= 0) {
                return  require(`@/components/game/page/${this.config.ctrl}.vue`).default
            }
            return  require(`@/components/game/ctrl/${this.config.ctrl}.vue`).default
        },
        language() {
            return this.$store.state.config.page.language;
        }
    },
    watch: {
        $route() {
            this.getConfig()
        },
        loading(newV) {
            this.$store.commit('set_loading', newV)
        },
        language(newLan) {
            if (newLan) {
                this.$i18n.locale = newLan;
            }
        }
    },
    methods: {
        // 获取页面配置信息
        getConfig() {
            this.loading = true
            this.error = null
            this.$store.dispatch('init_page', this.$route.query.id)
        },
    },
    data() {
        return {
            loading: true,
            error: null,
        }
    },
}
</script>

<style lang="less" scoped>
.spinning_modal {
    position:fixed;
    width:100%;
    height: 100%;
    z-index: 10000;
}
</style>